import React from 'react';

const Notfound = () => {
  return <div>Not Found</div>;
};

export default Notfound;
